module.exports = __webpack_public_path__ + "static/media/paper.84cb6858.svg";